export default "__VITE_ASSET__C_KD1iP2__"